import { Photo, Section, SectionHeading, StickerCard } from "@/components/ui";
import { ABOUT_WAY } from "@/data/about";
import { PHOTOS } from "@/data/photos";

/** Four principles that shape every A Learning Lab programme, beside a real programme photo. */
export function AboutWaySection() {
  return (
    <Section tone="sunTint" labelledBy="about-way-title" testId="about-way">
      <SectionHeading id="about-way-title" title={ABOUT_WAY.title} />
      <div className="mt-8 grid gap-6 lg:grid-cols-12 lg:gap-10">
        <div className="mx-auto w-full max-w-sm lg:col-span-5 lg:max-w-none lg:self-center">
          <Photo
            photo={PHOTOS.instructor}
            ratio="aspect-[1/1] lg:aspect-[5/4]"
            imgClassName="object-[50%_25%]"
            sizes="(min-width: 1024px) 40vw, 90vw"
            testId="about-way-photo"
          />
        </div>
        <ul className="grid items-start gap-3 sm:grid-cols-2 sm:gap-4 lg:col-span-7">
          {ABOUT_WAY.pillars.map((pillar) => (
            <li key={pillar.id}>
              <StickerCard tone="white">
                <h3 className="font-heading text-xl font-bold leading-tight">{pillar.title}</h3>
                <p className="mt-2 text-sm text-ink/70 sm:text-base">{pillar.text}</p>
              </StickerCard>
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
}
